import {Routes, RouterModule} from '@angular/router';
import {LoggedInGuard} from '../guards/auth.guard';
import {DashboardComponent} from '../../dashboard/dashboard.component';
import {ProtectedComponent} from '../../protected/protected.component';
import { CaseTemplateComponent } from '../../dashboard/case-template/caseTemplate.component';
import { UserListComponent } from 'app/dashboard/user-list/user-list.component';
import { AnnualReportFormComponent } from 'app/annual-report-form/annual-report-form.component';
import { RecommendationTrackerComponent } from 'app/recommendation-tracker/recommendation-tracker.component';

export const SECURE_ROUTES: Routes = [
    { path: 'protected', component: ProtectedComponent, canActivate: [LoggedInGuard] },
    { path: 'dashboard', component: DashboardComponent, canActivate: [LoggedInGuard] },
    { path: 'case/:id', component: CaseTemplateComponent, canActivate: [LoggedInGuard] },
    { path: 'case/:id/:analysis', component: CaseTemplateComponent, canActivate: [LoggedInGuard] },
    { path: 'users', component: UserListComponent, canActivate: [LoggedInGuard] },
    { path: 'annual-report', component: AnnualReportFormComponent, canActivate: [LoggedInGuard] },
    { path: 'recommendation-tracker', component: RecommendationTrackerComponent, canActivate: [LoggedInGuard] }
];
